import merge from 'lodash/merge'
import { pickLocaleNamespace } from 'vue_features/shared/helpers/i18n_helper'
import { helpers } from 'vue_features/shared/i18n'

export default merge({}, pickLocaleNamespace(helpers, 'session'))
